<script setup lang="ts">
import type { Opportunity } from '@/api-swagger'
import { printCurrency } from '@/utils/numbers'
import { formatDate } from '@/utils/dateUtils'
import ArrowForecast from '@/components/common/ui/ArrowForecast.vue'
import PartnerButtonRedirect from '@/components/common/buttons/PartnerButtonRedirect.vue'
import { useSelectionsStore } from '@/stores/useSelectionsStore'
import { storeToRefs } from 'pinia'
const { salesFamilyOpportunitySelections } = storeToRefs(useSelectionsStore())

defineProps({
  opportunity: {
    type: Object as () => Opportunity,
    required: true,
  },
})

const emit = defineEmits(['openModal'])
</script>

<template>
  <div class="card bg-base-100 shadow-md max-w-full cursor-move">
    <div class="p-4">
      <div class="w-max max-w-fit">
        <PartnerButtonRedirect
          :partner-name="opportunity.partnerId?.name"
          :partner-id="opportunity.partnerId?.id"
          openNewTab
        />
      </div>

      <div class="flex justify-between items-center mb-3">
        <h6 class="card-title text-base">{{ opportunity.name }}</h6>
      </div>

      <p><strong>Signature : </strong>{{ formatDate(opportunity.dateDeadline) }}</p>
      <p>
        <strong>Montant : </strong
        >{{ printCurrency(opportunity.expectedRevenue + opportunity.recurringRevenue) }}
      </p>
      <p><strong>Commercial : </strong>{{ opportunity.userName }}</p>
      <div class="card-actions mt-2 align-middle justify-between items-center">
        <div class="flex align-middle items-center gap-2">
          <div class="badge badge-secondary p-3 rounded-lg" v-if="opportunity.salesFamily">
            <span>{{
              salesFamilyOpportunitySelections.find(
                (type) => type.value === opportunity.salesFamily,
              )?.name || opportunity.salesFamily
            }}</span>
          </div>
          <div class="tooltip tooltip-top" data-tip="Forecast ⭐⭐⭐">
            <ArrowForecast :params="{ data: { priority: Number(opportunity.priority) } }" />
          </div>
        </div>
        <div class="tooltip tooltip-top" data-tip="Détails">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-three-dots-vertical cursor-pointer no-drag shrink-0"
            viewBox="0 0 16 16"
            @click="emit('openModal', opportunity)"
          >
            <path
              d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  user-select: none;
}
</style>
